import ContactForm from "./template.js";
import { connect } from "react-redux";
import { get } from "lodash";

const mapStateToProps = state => ({
  contactFormOpen: get(state, "contactFormOpen")
});

const mapDispatchToProps = dispatch => ({
  closePanel: () => dispatch({ type: "CLOSE_CONTACT_FORM" })
});

const ConnectedContactForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactForm);

export default ConnectedContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js